import { Type } from '@sinclair/typebox';
const cartValidationCodesBaseSchema = Type.Union([
    Type.Literal('country_code_invalid'),
    Type.Literal('currency_invalid'),
    Type.Literal('email_invalid'),
    Type.Literal('phone_number_invalid'),
]);
const cartValidationCodesCompanySchema = Type.Union([Type.Literal('company_name_invalid')]);
const cartValidationCodesShippingAddressSchema = Type.Union([
    Type.Literal('shipping_address_missing'),
    Type.Literal('shipping_po_box_not_valid_for_shipping'),
    Type.Literal('shipping_military_postal_not_valid_for_shipping'),
    Type.Literal('shipping_firstname_invalid'),
    Type.Literal('shipping_lastname_invalid'),
    Type.Literal('shipping_address1_invalid'),
    Type.Literal('shipping_city_invalid'),
    Type.Literal('shipping_postal_code_invalid'),
    Type.Literal('shipping_state_or_province_invalid'),
]);
const cartValidationCodesBillingAddressSchema = Type.Union([
    Type.Literal('billing_address_missing'),
    Type.Literal('billing_firstname_invalid'),
    Type.Literal('billing_lastname_invalid'),
    Type.Literal('billing_address1_invalid'),
    Type.Literal('billing_city_invalid'),
    Type.Literal('billing_postal_code_invalid'),
    Type.Literal('billing_state_or_province_invalid'),
    Type.Literal('billing_country_code_invalid'),
]);
const cartValidationCodesTaxSchema = Type.Union([
    /**
     * Failed to calculate tax for the order
     */
    Type.Literal('tax_calculation_failed'),
    /**
     * No address found to perform a tax calculation on
     */
    Type.Literal('tax_no_address_found'),
    /**
     * Missing required address data for tax calculation
     */
    Type.Literal('tax_missing_address_data'),
    /**
     * Invalid postal code provided for tax calculation
     */
    Type.Literal('tax_invalid_postal_code'),
    /**
     * Parameter validation error from the tax provider
     */
    Type.Literal('tax_param_validation_error'),
    /**
     * Unknown tax error during tax calculation
     */
    Type.Literal('tax_unknown_error'),
    /**
     * Internal server error during tax calculation
     */
    Type.Literal('tax_internal_error'),
]);
const cartValidationCodesVatSchema = Type.Union([Type.Literal('vat_number_not_validated'), Type.Literal('vat_number_invalid')]);
const cartValidationCodesShippingMethodSchema = Type.Union([Type.Literal('shipping_method_missing')]);
const cartValidationCodesPaymentSchema = Type.Union([Type.Literal('payment_already_paid'), Type.Literal('payment_method_missing')]);
const cartValidationCodesSchema = Type.Union([
    cartValidationCodesBaseSchema,
    cartValidationCodesCompanySchema,
    cartValidationCodesShippingAddressSchema,
    cartValidationCodesBillingAddressSchema,
    cartValidationCodesTaxSchema,
    cartValidationCodesVatSchema,
    cartValidationCodesShippingMethodSchema,
    cartValidationCodesPaymentSchema,
]);
export const cartValidationSchema = Type.Array(Type.Object({
    code: cartValidationCodesSchema,
}));
//# sourceMappingURL=validation.js.map